const COMMERCIAL = {
  id: 'commercial',
  label: 'Industrial, Manufacturing',
  color: 'rgba(241, 126, 19, 1)',
  mCodes: ['14', '15', '20'],
}

const RETAIL = {
  id: 'retail',
  label: 'Retail, Mixed Use',
  color: 'rgba(255, 65, 105, 1)',
  mCodes: ['25', '47'],
}

const OFFICE = {
  id: 'office',
  label: 'Office',
  color: 'rgba(85, 72, 240, 1)',
  mCodes: ['26'],
}

const HOSPITALITY = {
  id: 'hospitality',
  label: 'Hospitality, Hotel, Etc.',
  color: 'rgba(175, 122, 184, 1)',
  mCodes: ['12', '13'],
}

const LAND = {
  id: 'land',
  label: 'Land',
  color: 'rgba(20, 204, 148, 1)',
  mCodes: ['10', '11', '17', '18', '21'],
}

const PUBLIC_AMENITIES = {
  id: 'publicAmenities',
  label: 'Government',
  color: 'rgba(113, 92, 12, 1)',
  mCodes: ['28', '30', '31', '32', '33', '34', '35', '36', '37', '38'],
}

const RESIDENTIAL = {
  id: 'residential',
  label: 'Multi Family',
  color: 'rgba(17, 191, 229, 1)',
  mCodes: ['22', '23', '27', '40', '41', '42', '43'],
}

const SINGLE_FAMILY = {
  id: 'single-family',
  label: 'Single Family Residential',
  color: 'rgba(133, 140, 145, 1)',
  mCodes: ['44'],
}

const UNASSIGNED = {
  id: 'unassigned',
  label: 'General Commercial',
  color: 'rgba(255, 224, 20, 1)',
  mCodes: ['16', '19', '24', '29', '39', '45', '46'],
}

export const ZONING_PARENT_MCODES_MAP = [
  RETAIL,
  COMMERCIAL,
  LAND,
  OFFICE,
  RESIDENTIAL,
  PUBLIC_AMENITIES,
  SINGLE_FAMILY,
  HOSPITALITY,
  UNASSIGNED,
] as const

export const PARCEL_COLORS_MAP = (function () {
  const items: Map<string, string> = new Map()
  for (const map of ZONING_PARENT_MCODES_MAP) {
    for (const code of map.mCodes) {
      items.set(code, map.color || '#FFF')
    }
  }
  return items
})()

export const PARCEL_TYPES_MAP = (function () {
  const items: Map<string, (typeof ZONING_PARENT_MCODES_MAP)[0]> = new Map()
  for (const map of ZONING_PARENT_MCODES_MAP) {
    items.set(map.id, map)
  }
  return items
})()

export const PARCEL_TYPES_BY_MCODE_MAP = (function () {
  const items: Record<string, string> = {}
  for (const map of ZONING_PARENT_MCODES_MAP) {
    for (const code of map.mCodes) {
      items[code] = map.id
    }
  }
  return items
})()

export const PARCEL_MCODES_LABEL_MAP = (function () {
  const items: Record<string, string> = {}
  for (const map of ZONING_PARENT_MCODES_MAP) {
    for (const code of map.mCodes) {
      items[code] = map.label
    }
  }
  return items
})()

export const PARCEL_LAYER_COLORS = (function () {
  const items = []
  for (const map of ZONING_PARENT_MCODES_MAP) {
    items.push(...map.mCodes.map((code) => [code, map.color]).flat())
  }
  return items
})()
